// Ticket #215: detect the INSEE "[NON DIFFUSIBLE]" marker returned by
// recherche-entreprises.api.gouv.fr for companies that opted out of having
// their identity published by French public services. Matches both spellings
// ("[NON DIFFUSIBLE]" and "[NON-DIFFUSIBLE]"), case-insensitive.
const NON_DIFFUSIBLE_PATTERN = /\[NON[- ]DIFFUSIBLE\]/i

export function isNonDiffusible(value?: string | null): boolean {
  return value ? NON_DIFFUSIBLE_PATTERN.test(value) : false
}
